import React from 'react'
import { connect } from 'react-redux'
import CouponPresetActions from '../../Redux/CouponPresetRedux'

class DeletePreset extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _delete = (event) => {
    event.preventDefault()
    let id = this.props.detail.id
    this.props.deleteCouponPreset(id)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '30vw' }}>
        <div className='title-block'>
          <h3 className='title'>Delete Preset</h3>
        </div>
        <div className='mt-2'>
          <p>Confirm deletion for:</p>
          <p className='text-center'>Provider Name: {this.props.detail.coupon_providers ? this.props.detail.coupon_providers.name : ''}</p>
          <p className='text-center'>Card Type: {this.props.detail.card_type || ''}</p>
          <p className='text-center'>Prefix: {this.props.detail.prefix || ''}</p>
        </div>
        <form onSubmit={(event) => this._delete(event)}>
          <div className='row'>
            <div className='col-12 text-right'>
              <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}>Cancel</button>
              <button className='btn btn-danger' type='submit'>Delete</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  deleteCouponPreset: (data) => dispatch(CouponPresetActions.deleteCouponPresetRequest(data))
})

export default connect(stateToProps, dispatchToProps)(DeletePreset)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/DeletePreset.js